import React from 'react'
import './styles'

import { Link } from 'react-router-dom'

# componennts
import Pager      from '/components/pager/history-pager'
import Spinner    from '/components/spinner'
import Filters    from '/components/filters'
import List       from '/components/list'
import Datetime   from '/components/datetime'

import StateLabel from '/components/state-label'
# import StateActions   from '/components/state-label/actions'

import ProgressBar    from 'react-bootstrap/lib/ProgressBar'

import ListingCard  from '/components/listing-card'
import UserCard     from '/components/user-card'

import {
  state_options
} from '/models/bulk-customization'

import {
  withBulkCustomizations
  withRPC
} from './queries'

interval = null

export default \
withBulkCustomizations \
withRPC \
class BulkCustomizations extends React.Component

  refetch: =>
    @props.bulk_customizationsRefetch?()

  componentDidMount: =>
    interval = setInterval @refetch, 10000

  componentWillUnmount: =>
    clearInterval interval

  rpc: (id, method)=>
    {bulk_customization, errors} = await @props.rpc id, method
    flash.error errors if errors?.length

  render: ->
    <div className="BulkCustomizations">
      <header>
        <h1>Bulk Customizations</h1>
      </header>
        <section className="content">
        {@filters()}
        {@list()}
        {@pager()}
      </section>
    </div>

  filters: ->
    <Filters>
      <Filters.State options={state_options}/>
      <span className="pull-right">
        <Pager meta={@props.bulk_customizationsPagination} buffer={2}/>
      </span>
    </Filters>

  progress: (a,b)->
    done = a is b
    <ProgressBar title="#{a} / #{b}">
      <ProgressBar active={not done} bsStyle={if done then 'success' else 'info'} now={a / b * 100} key={1} />
    </ProgressBar>

  list: ->
    return <Spinner/> if @props.bulk_customizationsLoading
    <List>
      {@header()}
      {for bc in @props.bulk_customizations
        <List.Row key={bc._key}>

          <List.Cell className="user">
            <UserCard user={bc.user} />
          </List.Cell>

          <List.Cell className="listing">
            <ListingCard listing={bc.listing} />
          </List.Cell>

          <List.Cell className="completion">
            <div>{bc.customizations_to_sync} / {bc.customizations_processed}</div>
            {@progress bc.customizations_to_sync, bc.customizations_processed}
          </List.Cell>

          <List.Cell className="created-at">
            <Datetime date={bc.created_at}/>
          </List.Cell>

          <List.Cell className="status">
            <StateLabel model={bc}/>
          </List.Cell>

        </List.Row>

      }
    </List>

  header: ->
    <List.HeaderRow>
      <List.Header className="user">Initiator</List.Header>
      <List.Header className="listing">Listing</List.Header>
      <List.Header className="completion">Progress</List.Header>
      <List.Header className="created-at">Created At</List.Header>
      <List.Header className="status">Status</List.Header>
    </List.HeaderRow>

  pager: ->
    <div className="text-center">
      <Pager meta={@props.bulk_customizationsPagination} buffer={4}/>
    </div>
